import Language from '../../lang/language';

const requiredErrorKey = 'errors.formFields.required';

const required = fieldName => (value) => {
  let errorKey = requiredErrorKey;
  if (fieldName !== undefined && fieldName.trim().length > 0) {
    const errorKeyFieldSpecific = `${requiredErrorKey}.${fieldName}`;
    
    errorKey = Language.doesTranslationExist(errorKeyFieldSpecific) ? errorKeyFieldSpecific : requiredErrorKey;
  }
  
  if (typeof value === 'boolean') {
    return value ? undefined : errorKey;
  }
  
  if (value === undefined || value.trim().length === 0) {
    return errorKey;
  }
};

export default required;
